module.exports = {
  "slide-nav": {
    "position": "absolute",
    "zIndex": 1000
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2a00ecea!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-slide-nav/index.vue
// module id = 168
// module chunks = 0 1